import Image from 'next/image'
import React from 'react'
import { useEventLogging } from '@packages/jslib'
import { useRouter } from 'next/router'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import useExamInform from '@hooks/useExamInform'
import { AlertModal } from '@components/Modal'
import { createOrUpdateTodayDailyDeliveryStatus } from '@lib/query/mutateFunction'
import { dailyDeliveryKeys } from '@hooks/reactQuery/useDailyDelivery'

type ExamSubmitButtonProps = {
  viewResultMode: boolean
  handleSubmitQuestionInformation: () => void
  isDelivery?: boolean
}

const ExamSubmitButton: React.FC<ExamSubmitButtonProps> = ({
  viewResultMode,
  handleSubmitQuestionInformation,
  isDelivery,
}) => {
  const carepartnerUrl = process.env.NEXT_PUBLIC_CAREPARTNER_URL ?? 'https://carepartner.kr'
  const [finishPublicModal, setFinishPublicModal] = React.useState(false)
  const router = useRouter()
  const { currentQuestionGroup } = useExamInform(isDelivery)
  const { trackButtonClick } = useEventLogging()
  const className =
    'flex bg-bosalpim text-white font-bold w-[136px] sm:w-[198px] h-[44px] sm:h-[52px] text-lg rounded-lg mr-2 justify-center items-center'
  const closeActionForFinishPublicModal = () => {
    router.push('/')
  }
  const submitActionForFinishPublicModal = () => {
    trackButtonClick({
      name: 'Take Exam Modal - SignUp',
    })
    router.push(`${carepartnerUrl}/login/?prevPath=${process.env.NEXT_PUBLIC_CBT_URL || '/'}`)
  }

  const { mutate } = useMutation(createOrUpdateTodayDailyDeliveryStatus())
  const queryClient = useQueryClient()

  return (
    <>
      <AlertModal
        show={finishPublicModal}
        setShow={setFinishPublicModal}
        data={{
          body: (
            <div>
              케어파트너 회원이 되시면
              <br />
              CBT 사전 모의고사 모든 문제를
              <br />
              무료로 평생 응시할 수 있습니다.
            </div>
          ),
          submitLabel: '회원가입하고 모든 문제풀기',
          submitAction: submitActionForFinishPublicModal,
          closeAction: closeActionForFinishPublicModal,
          xButton: true,
        }}
      />
      {viewResultMode ? (
        <button
          className={className}
          onClick={() => {
            trackButtonClick({
              name: 'Go to Exam List',
            })
            if (isDelivery) {
              mutate(
                { status: 'success' },
                {
                  onSuccess: () => {
                    queryClient.invalidateQueries(dailyDeliveryKeys.status())
                    router.push('/delivery')
                  },
                }
              )
            } else {
              router.push('/')
            }
            // 맛보기 비로그인시 해답 보기 가능했을 때, 나가기 버튼 누를 시 회원가입유도하였던 부분.
            // 맛보기 해답을 로그인 상태에서만 볼 수 있도록 변경하였지만, 추후 되살릴 가능성 있기에 주석처리만 하는 것으로 결정.
            // if (currentQuestionGroup.type === 'public') {
            //   setFinishPublicModal(true)
            //   trackShow({
            //     name: 'Take Exam Modal',
            //   })
            // } else {
            //   router.push('/')
            // }
          }}
        >
          <span>
            {currentQuestionGroup.type === 'public'
              ? '나가기'
              : isDelivery
              ? '완료하기'
              : '다시 풀기'}
          </span>
        </button>
      ) : (
        <button className={className} onClick={handleSubmitQuestionInformation}>
          <Image
            className={'mr-3 '}
            src={'/exam/submit.png'}
            alt={'submit'}
            width={'16'}
            height={'20'}
          />
          {'답안 제출'}
        </button>
      )}
    </>
  )
}

export default ExamSubmitButton
